import { createFileRoute } from '@tanstack/react-router';
import { ApiError } from '../lib/api.js';
import {
  ProjectDashboardTab,
  IntegratedProductDashboardTab,
} from '../components/features/project/index.js';
import { useProjectDetail } from '../hooks/useProjects.js';
import { DeliverableFoldersSection } from '../components/features/project/DeliverableFoldersSection.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 案件詳細ページの「ダッシュボード」タブ（既定タブ）。Gen2として取得できればProjectDashboardTab、404ならGen1統合プロダクトとしてIntegratedProductDashboardTabを表示する
 * @graph-connects useProjectDetail [calls] Gen2案件かどうかの判定
 * @graph-connects ProjectDashboardTab [calls] Gen2案件のダッシュボードタブ描画
 * @graph-connects IntegratedProductDashboardTab [calls] Gen1統合プロダクトのダッシュボードタブ描画（Gen2が404のときのみ）
 * @graph-connects DeliverableFoldersSection [calls] デザイン成果物フォルダの確認と作成
 */
export const Route = createFileRoute('/projects/$pjKey/')({
  component: ProjectDashboardPage,
});

/**
 * @graph-connects ProjectDashboardTab [calls] Gen2案件のダッシュボードタブ描画
 * @graph-connects IntegratedProductDashboardTab [calls] Gen1統合プロダクトのダッシュボードタブ描画
 * @graph-connects DeliverableFoldersSection [calls] デザイン成果物フォルダの確認と作成
 */
function ProjectDashboardPage() {
  const { pjKey } = Route.useParams();
  const { error } = useProjectDetail(pjKey);
  const isGen2NotFound = error instanceof ApiError && error.status === 404;

  return (
    <div className="space-y-6">
      {isGen2NotFound ? (
        <IntegratedProductDashboardTab pjKey={pjKey} />
      ) : (
        <ProjectDashboardTab pjKey={pjKey} />
      )}
      <DeliverableFoldersSection key={pjKey} pjKey={pjKey} />
    </div>
  );
}
